import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { decode } from 'blurhash'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BlurhashImg',
  props: {
    hash: null
  },
  setup(__props: any) {

const props = __props as {
  hash: string
};



const canvas = ref<HTMLCanvasElement>()
const size = 128

onMounted(() => {
  const pixels = decode(props.hash, size, size, 1)
  const imageData = new ImageData(pixels, size, size)
  const context = canvas.value?.getContext('2d')
  context?.putImageData(imageData, 0, 0)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "canvas",
    ref: canvas,
    class: "canvas",
    width: size,
    height: size
  }, null, 512))
}
}

})